import modalLoader from 'containers/modalsDispatcher/loader';

export const showCounterpartyDetailsModalLoader = modalLoader({
  key: 'COUNTERPARTY_DETAILS_MODAL;',
  getModal: () => import(/* counterparty-details-modal */'./CounterpartyDetailsModal'),
});
